"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsNumerable = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var lodash_times_1 = tslib_1.__importDefault(require("lodash.times"));

var steps_1 = tslib_1.__importDefault(require("antd/es/steps"));

var __1 = require("..");

exports.StepsNumerable = function (_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      maxSteps = _ref.maxSteps,
      currentStep = _ref.currentStep,
      onChangeStep = _ref.onChangeStep;
  return React.createElement(steps_1["default"], {
    direction: direction,
    current: currentStep,
    onChange: onChangeStep
  }, lodash_times_1["default"](maxSteps, function (step) {
    return React.createElement(__1.Step, {
      icon: step + 1,
      key: step
    });
  }));
};